import React from 'react'
import OurServices from './services copy 6'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
export default function ServicesMain(params) {
        const context = useContext(NoteContext)
        const {setBars} = context
        setBars('grey-bars')
    return (
        <div>
            <div className="">
                <div className="">
                    <div style={{ backgroundColor: '#f8f9f9' }}>
                        <div className="container p-5">
                            <div className="d-flex justify-content-between">
                            <h1 className='serviceheading' style={{ fontWeight: 'bold' }}>OUR SERVICES</h1>
                            <button style={{borderRadius:'0px',backgroundColor:"#A10302",color:'white'}} className="btn">GET IN TOUCH</button>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className='mb-5'>
                            <OurServices />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/servicesMain.jsx